
define('require-css/css!js-css/events-band',[],function(){});
